var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-md-time",
    "data-name": "Icon ionic-md-time",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.001,
    height: 12.001,
    viewBox: "0 0 12.001 12.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21412",
    "data-name": "Path 21412",
    d: "M9.37,3.375a6,6,0,1,0,6.006,6A6,6,0,0,0,9.37,3.375Zm.006,10.8a4.8,4.8,0,1,1,4.8-4.8A4.8,4.8,0,0,1,9.375,14.176Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#a2a5b1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21413",
    "data-name": "Path 21413",
    d: "M17.453,10.688h-.916v3.663l3.205,1.923.458-.751-2.747-1.629Z",
    transform: "translate(-11.178 -7.731)",
    fill: "#a2a5b1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/TimeIcon.c8a08ee140e191fc5d16d92c8200e4eb.svg";
export { ForwardRef as ReactComponent };